import { PeriodAnalysis } from '@cloudmatize/traffic-hub'

export function PeriodAnalysisPage() {
  return <PeriodAnalysis />
}
